export default __webpack_public_path__ + "static/media/contact-us-modern-03.198d3154.jpg";